import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    release: environment.sentry.release,
    environment: environment.name,
    // Google's gapi client loader (apis.google.com/js/api.js) occasionally throws
    // from its own internal callback plumbing on Safari/iOS (JTMS-FRONT-END-EN).
    // No first-party frame is involved, so filter it at the source instead of
    // reporting it as a JTMS error.
    denyUrls: [/apis\.google\.com\/js\/api\.js/],
  });
}

bootstrapApplication(AppComponent, { ...appConfig }).catch((err) =>
  console.error(err),
);
